
  import {Component, Vue} from 'vue-property-decorator';
  import AppDialog from '@/modules/Popup/components/AppDialog.vue';
  import {IApp} from "@/interfaces/app.interface";
  import moment from "moment";
  import {IAppState} from "@/interfaces/app-state.interface";

  @Component({
    components: {
      AppDialog,
    },
  })
  export default class BankIframePopup extends Vue {
    $refs: any;
    currentPopup = { blockName: 'payment', dialogName: 'bankIframePopup' };
    timer = 180;
    intervalId = null;
    timeOutUrl = '';

    get storeState(): IAppState { return this.$store.state; }
    get payloadPopup() { return this.$store.getters['dialog/getPopupPayload'](this.currentPopup); }
    get isUser() { return this.storeState.auth.isUser; }

    mounted() {
      const hostUrl = window.location.origin;
      const resultPageUrl = IApp.RoutePath[IApp.ROUTE_NAME.PAGE_PAYMENT_RESULT];
      this.timeOutUrl = `${hostUrl}${resultPageUrl}?type=timeOut&status=error`;

      this.intervalId = setInterval(() => {
        this.timer -= 1;
        if (!this.timer) {
          if (this.intervalId) clearInterval(this.intervalId);
        }
      }, 1000);

      // Слушаем сообщения из iframe
      window.addEventListener('message', this.onIframeMessage);
    }

    onIframeMessage(event: MessageEvent) {
      // Проверяем origin — важно для безопасности
      if (event.origin !== window.location.origin) return;

      if (event.data?.type === 'PAYMENT_RESULT_CLOSE' && event.data?.data) {
        let { status, typeContent } = this.$route.query;
        if (typeContent === 'saveCard' && status === 'success' && this.isUser) {
          this.$store.commit('auth/updateUserAccessProp', { name: 'hasSavedCards', value: true });
        }

        this.$refs.appDialog.onClose();
      }
    }

    destroyed() {
      if (this.intervalId) clearInterval(this.intervalId);
    }
  }
